import React from "react";
import PropTypes from "prop-types";
import {
  CheckboxGroupContainer,
  CheckboxGroupTitle,
  CheckboxGroupSubtitle,
  CheckboxOptionsContainer,
  CheckboxOption,
  CheckboxInput,
  CheckboxLabel,
} from "./CheckboxGroup.styles";

const CheckboxGroup = ({
  title,
  subtitle,
  options = [],
  value = [],
  onChange,
  name,
  className = "",
  disabled = false,
  variant = "default",
}) => {
  const handleOptionChange = (optionValue) => {
    if (!disabled && onChange) {
      const newValue = value.includes(optionValue)
        ? value.filter((v) => v !== optionValue)
        : [...value, optionValue];
      onChange(newValue);
    }
  };

  return (
    <CheckboxGroupContainer className={className} variant={variant}>
      {title && <CheckboxGroupTitle>{title}</CheckboxGroupTitle>}
      {subtitle && <CheckboxGroupSubtitle>{subtitle}</CheckboxGroupSubtitle>}

      <CheckboxOptionsContainer>
        {options.map((option) => (
          <CheckboxOption
            key={option.id || option.value}
            isSelected={value.includes(option.value)}
            disabled={disabled}
            onClick={() => handleOptionChange(option.value)}
          >
            <CheckboxInput
              type="checkbox"
              name={name}
              value={option.value}
              checked={value.includes(option.value)}
              onChange={() => handleOptionChange(option.value)}
              disabled={disabled}
            />
            <CheckboxLabel isSelected={value.includes(option.value)}>
              {option.label}
            </CheckboxLabel>
          </CheckboxOption>
        ))}
      </CheckboxOptionsContainer>
    </CheckboxGroupContainer>
  );
};

CheckboxGroup.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "card"]),
};

export default CheckboxGroup;
